import { useState, useEffect } from 'react';
import dayjs from 'dayjs';

import * as api from '../utils/api';
import * as URLS from '../constants/urls';

const timeLoop = 60000 * 5; // ~ 5 phut

export const LOG_TYPE = {
  startSession: 'S_SES',
  endSession: 'E_SES',
};

const useNotificationModal = () => {
  const [isOpenModal, setOpenModal] = useState(false);
  const [isNotificationLoading, setNotificationLoading] = useState(false);
  const [notification, setNotification] = useState(null);
  const [selectedType, setSelectedType] = useState(LOG_TYPE.startSession);

  const createNotification = async () => {
    try {
      await api.post(URLS.CREATE_NOTIFICATION_LOG_MODAL, {
        date: dayjs().format('YYYYMMDD'),
        type: selectedType,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleCloseModal = async () => {
    setOpenModal(false);
    createNotification();
  };

  const fetchNotification = async () => {
    if (
      Number(dayjs().format('HHmm')) > 1445 ||
      Number(dayjs().format('HHmm')) < 830
    ) {
      if (Number(dayjs().format('HHmm')) < 830) {
        setTimeout(() => {
          fetchNotification();
        }, timeLoop);
      }
      return;
    }
    setNotificationLoading(true);
    try {
      const { data } = await api.get(
        `${URLS.GET_NOTIFICATION_MODAL}?date=${dayjs().format(
          'YYYYMMDD'
        )}&type=${LOG_TYPE.startSession}`
      );
      if (data?.notification) {
        setNotification({
          timeSend: dayjs(Number(data.notification.time_send)).format(
            'DD/MM/YYYY HH:mm'
          ),
          type: data.notification.type,
          message: data.notification.message,
          follow: data.follows,
        });
        setOpenModal(true);
        setSelectedType(LOG_TYPE.startSession);
      }
    } catch (error) {
      console.error(error);
    }
    setNotificationLoading(false);
  };

  const fetchHistoryNotification = async () => {
    if (
      Number(dayjs().format('HHmm')) > 1900 ||
      Number(dayjs().format('HHmm')) < 2359
    ) {
      if (Number(dayjs().format('HHmm')) < 2359) {
        setTimeout(() => {
          fetchHistoryNotification();
        }, timeLoop);
      }
      return;
    }
    setNotificationLoading(true);
    try {
      const { data } = await api.get(
        `${URLS.GET_NOTIFICATION_MODAL}?date=${dayjs().format(
          'YYYYMMDD'
        )}&type=${LOG_TYPE.endSession}`
      );
      if (data?.notification) {
        setNotification({
          timeSend: dayjs(Number(data.notification.time_send)).format(
            'DD/MM/YYYY HH:mm'
          ),
          type: data.notification.type,
          message: data.notification.message,
          follow: null,
        });
        setOpenModal(true);
        setSelectedType(LOG_TYPE.endSession);
      }
    } catch (error) {
      console.error(error);
    }
    setNotificationLoading(false);
  };

  useEffect(() => {
    fetchNotification();
    fetchHistoryNotification();
  }, []);

  return {
    isOpenModal,
    isNotificationLoading,
    notification,
    handleCloseModal,
    selectedType,
  };
};

export default useNotificationModal;
